module.exports = __webpack_public_path__ + "assets/img/bg.07263276.png";